import React from "react";

import CloseIcon from "@material-ui/icons/Close";
export default function IconUnavailable() {
  return <CloseIcon className="staff-icon" />;
}
